import { createEntityAdapter, createSelector } from "@reduxjs/toolkit";
import { apiSlice } from "./apiSlice";
import { buildQueryString } from "../utils/buildQueryString";

// Create an adapter for the refunds list
const refundListAdapter = createEntityAdapter({
  selectId: (refund) => refund.id,
});

const initialState = refundListAdapter.getInitialState();

// Define the slice
export const refundListSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // ✅ Fetch list of refund
    getRefundList: builder.query({
      query: (filters) => buildQueryString("refund_orders", filters || {}),
      transformResponse: (responseData) => {
        const loadedRefundList = responseData.data.map((item) => ({
          ...item,
        }));

        return refundListAdapter.setAll(initialState, loadedRefundList);
      },
      providesTags: (result) =>
        result
          ? [
              { type: "refund", id: "refundList" },
              ...result.ids.map((id) => ({ type: "refund", id })),
            ]
          : [{ type: "refund", id: "refundList" }],
    }),

    // ✅ Fetch individual refund details
    getRefundById: builder.query({
      query: (refundId) => `refund_orders/${refundId}`,
      transformResponse: (responseData) => responseData.data,
      providesTags: (result, error, refundId) => [
        { type: "refund", id: refundId },
      ],
    }),

    // patchRefundStatus: builder.mutation({
    //   query: ({ id, status, remarks }) => ({
    //     url: `orders/refund_requests`,
    //     method: "PATCH",
    //     body: { shipment_id: id, status, remarks },
    //   }),
    //   // transformResponse: (response) => {
    //   //   console.log("Refund PATCH response:", response);
    //   //   return response?.data;
    //   // },
    //   onQueryStarted: async (
    //     { id, status, remarks, filters },
    //     { dispatch, queryFulfilled }
    //   ) => {
    //     try {
    //       const { data: updatedRefund } = await queryFulfilled;

    //       dispatch(
    //         apiSlice.util.updateQueryData(
    //           "getRefundList",
    //           filters || {},
    //           (draft) => {
    //             const existing = draft.entities[id];
    //             if (existing) {
    //               Object.assign(existing, updatedRefund);
    //             }
    //           }
    //         )
    //       );
    //     } catch (err) {
    //       console.error("Failed to update refund:", err);
    //     }
    //   },
    //   invalidatesTags: (result, error, { id }) => [
    //     { type: "refund", id },
    //     { type: "refund", id: "refundList" },
    //   ],
    // }),
  }),
});

// Export hooks for API calls
export const {
  useGetRefundListQuery,
  useGetRefundByIdQuery,
  usePatchRefundStatusMutation,
} = refundListSlice;

// Select the refund filter state
const refundFilter = (state) => state.refundFilter;

// ✅ Select filtered refund from the state
const selectRefundListResult = createSelector(
  [refundFilter, (state) => state],
  (filter, state) =>
    refundListSlice.endpoints.getRefundList.select({
      status: filter.status,
      search: filter.search,
    })(state)
);

const selectRefundListData = createSelector(
  [selectRefundListResult],
  (refundListResult) => refundListResult?.data ?? initialState
);

// ✅ Adapter selectors for refund
export const {
  selectAll: selectRefunds,
  selectById: selectRefundById,
  selectIds: selectRefundIds,
} = refundListAdapter.getSelectors((state) => selectRefundListData(state));
